import { env } from "~/env"

export default function getAlternateUrl(url = "") {
  return `${env.NEXT_PUBLIC_VERCEL_URL}${url}`
}
